import {BaseDTO} from '../../../utils/base/dto';
import {ScreeningProcessDTO} from './screening-process';

export enum ResearchSource {
  SEMANTIC_SCHOLAR = 'SEMANTIC_SCHOLAR',
  SCOPUS = 'SCOPUS',
  PUBMED = 'PUBMED',
  SELF_CREATED = 'SELF_CREATED'
}

export enum ResearchExportType {
  CSV = 'CSV',
  BIBTEX = 'BIBTEX'
}

export interface ScreeningResultDTO {
  passed: boolean;
  criteria: string;
  reason: string;

  manuelOverride?: boolean;
  manuelReason?: string;
}

export interface ResearchPaperCreateDTO {
  title: string;
  abstractText: string;
  venue: string;
  referenceCount?: number;
  citationCount?: number;
  isOpenAccess?: boolean;
  authors: string;
  year: string;
  url?: string;
  pdfUrl?: string;
  semanticScholarId?: string;
  doi?: string;
  corpusId?: string;
  magId?: string;
  pubMedId?: string;
}

export interface ResearchPaperDTO extends BaseDTO {
  semanticScholarId?: string;
  doi?: string;
  corpusId?: string;
  magId?: string;
  pubMedId?: string;
  title: string;
  abstractText?: string;
  venue: string;
  referenceCount?: number;
  citationCount?: number;
  isOpenAccess?: boolean;
  authors: string;
  year: string;
  url?: string;
  source?: ResearchSource;
  pdfUrl?: string;
  hasDownloadedPdf?: boolean;
  projectId: number;

  queryIds?: number[];
  oldScreeningProcesses?: ScreeningProcessDTO[];
  latestScreeningRun?: ScreeningProcessDTO;
}


export interface ResearchPaperManuelScreeningDTO {
  passedOne?: boolean;
  passedTwo?: boolean;
  reason?: string;
}
